import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f43b9663911b0014d932ec/tgiquote/src/app/components/QuotationListClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f43b9663911b0014d932ec/tgiquote/src/components/Sidebar.tsx");
